// src/components/ui/BackToTopButton.jsx
import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll the page to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <button
      className={`
        fixed bottom-6 right-6
        md:bottom-10 md:right-10
        p-3 md:p-4
        bg-indigo-600 hover:bg-indigo-700
        text-white
        rounded-full
        shadow-lg hover:shadow-xl
        transition-all duration-300
        transform hover:scale-110
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
        z-50
        ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}
      `}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <Icon name="ArrowUp" size={24} />
    </button>
  );
};

export default BackToTopButton;